import { jsx as _jsx } from "react/jsx-runtime";
import { PropertyLine } from "./propertyLine";
import { Link } from "../../primitives/link";
/**
 * Wraps a link in a property line
 * @param props - PropertyLineProps and LinkProps
 * @returns property-line wrapped link
 */
export const LinkPropertyLine = (props) => {
    LinkPropertyLine.displayName = "LinkPropertyLine";
    return (_jsx(PropertyLine, { ...props, children: _jsx(Link, { ...props }) }));
};
//# sourceMappingURL=linkPropertyLine.js.map